export default {
  //Used in search bar, user details, etc. -------------------------------
  snap: {
    container: "relative inline-block text-left w-full",
    button: "inline-flex h-[40px] lg:h-[48px] justify-between w-full rounded-full border border-bordered px-4 py-2 bg-paper text-sm font-medium text-text focus:outline-none focus:ring-1 focus:ring-primary focus:ring-offset-0",
    panel: "absolute origin-top-right rounded-md shadow-md bg-paper ring-1 ring-bordered focus:outline-none mt-2 z-[9999]",
    searchInput: "w-full px-3 py-1 text-sm border rounded border-bordered rounded outline-none focus:outline-none focus:border-primary focus:shadow-none bg-canvas text-text",
    searchContainer: "p-2 border-b border-neutral_2",
    menuContainer: "rounded-lg overflow-hidden max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-neutral_2 scrollbar-track-transparent",
    menuItem: "text-text px-4 py-2 hover:bg-canvas cursor-pointer",
    menuItemSelected: "px-4 py-2 bg-primary/10 border-l-4 border-primary cursor-pointer text-primary font-medium transition-colors",
    menuItemDisabled: "px-4 py-2 text-text_secondary cursor-not-allowed",
    selectAllContainer: "px-4 py-2 mt-1 hover:bg-canvas cursor-pointer",
    divider: "border-t border-border my-1",
    resetButton: "absolute right-2 top-1/2 transform -translate-y-1/2 p-2 text-text_secondary hover:text-primary",
    highlight: "ring-2 ring-primary ring-opacity-50 border-primary",
    selectedText: "text-primary font-semibold",
    placeholderText: "text-text_secondary",
  },

  snap_compact: {
    container: "relative inline-block text-left w-full",
    button: "inline-flex h-[40px] justify-between w-full rounded-full px-4 py-2 bg-neutral text-sm font-medium text-text focus:outline-none focus:ring-1 focus:ring-primary focus:ring-offset-0",
    panel: "absolute origin-top-right rounded-2xl shadow-md bg-paper ring-1 ring-bordered focus:outline-none mt-2 z-[9999]",
    searchInput: "w-full px-3 py-1 text-sm border rounded border-bordered rounded outline-none focus:outline-none focus:border-primary focus:shadow-none bg-canvas text-text",
    searchContainer: "p-2 border-b border-neutral_2",
    menuContainer: "rounded-lg overflow-hidden max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-neutral_2 scrollbar-track-transparent",
    menuItem: "text-text px-4 py-2 hover:bg-canvas cursor-pointer",
    menuItemSelected: "px-4 py-2 bg-primary/10 border-l-4 border-primary cursor-pointer text-primary font-medium transition-colors",
    menuItemDisabled: "px-4 py-2 text-text_secondary cursor-not-allowed",
    selectAllContainer: "px-4 py-2 mt-1 hover:bg-canvas cursor-pointer",
    divider: "border-t border-border my-1",
    resetButton: "absolute right-2 top-1/2 transform -translate-y-1/2 p-2 text-text_secondary hover:text-primary",
    highlight: "ring-2 ring-primary ring-opacity-50 border-primary",
    selectedText: "text-primary font-semibold",
    placeholderText: "text-text_secondary/80",
  },

}
